export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
  articleCount: number;
  matchCount: number;
}

export const categories: Category[] = [
  {
    slug: 'football',
    name: '足球',
    icon: 'ri-football-line',
    description: '汇聚英超、西甲、欧冠、世界杯等全球顶级足球赛事，提供实时比分、深度分析和专业预测。',
    articleCount: 128,
    matchCount: 56,
  },
  {
    slug: 'basketball',
    name: '篮球',
    icon: 'ri-basketball-line',
    description: '覆盖NBA、CBA、欧冠篮球等主流篮球联赛，实时数据追踪，深度战术解析。',
    articleCount: 96,
    matchCount: 42,
  },
  {
    slug: 'tennis',
    name: '网球',
    icon: 'ri-base-station-line',
    description: '聚焦四大满贯、ATP、WTA等顶级网球赛事，专业数据分析与比赛预测。',
    articleCount: 74,
    matchCount: 38,
  },
  {
    slug: 'esports',
    name: '电竞',
    icon: 'ri-gamepad-line',
    description: '涵盖LOL、DOTA2、CS2、王者荣耀等热门电竞项目，赛事直播与深度复盘。',
    articleCount: 156,
    matchCount: 89,
  },
  {
    slug: 'table-tennis',
    name: '乒乓球',
    icon: 'ri-boxing-line',
    description: '关注世乒赛、奥运会、ITTF巡回赛等乒乓球顶级赛事，技术与战术全面解读。',
    articleCount: 45,
    matchCount: 22,
  },
  {
    slug: 'badminton',
    name: '羽毛球',
    icon: 'ri-flight-takeoff-line',
    description: '跟踪BWF世界巡回赛、汤尤杯、苏迪曼杯等羽毛球大赛，专业赛事前瞻与回顾。',
    articleCount: 38,
    matchCount: 18,
  },
];